import type { FeedbackMessages } from './en';

const nl: FeedbackMessages = {
  qualified: {
    title: 'Bedankt voor het voltooien van dit onderzoek!',
    body1: 'U kunt het browservenster nu sluiten.',
    body2: 'We hopen u snel weer te zien.',
    refCode: 'Referentiecode: {code}',
  },
  quotaFull: {
    title: 'Dit onderzoek is gesloten',
    body1: 'Bedankt voor uw interesse in ons onderzoek.',
    body2: 'Helaas hebben we al alle benodigde reacties ontvangen.',
    body3: 'We hopen u in een van onze toekomstige onderzoeken te zien!',
    refCode: 'Referentiecode: {code}',
  },
  terminated: {
    title: 'Bedankt voor het delen van uw feedback!',
    body1:
      'We hopen u binnenkort weer te zien in een van onze toekomstige onderzoeken. Tot die tijd wensen we u een fijne dag.',
    body2: 'Sluit dit browservenster.',
    refCode: 'Referentiecode: {code}',
  },
  mismatch: {
    title: 'Bedankt voor uw interesse',
    body1: 'Helaas behoort u niet tot de doelgroep voor dit specifieke onderzoek.',
    body2: 'U kunt deze pagina sluiten.',
    code: 'Code: {code}',
  },
  error: {
    title: 'We kunnen uw verzoek niet verwerken',
    linkProblemDetailed:
      'Er is een probleem met de link die u heeft gevolgd. Controleer of de link in de adresbalk overeenkomt met de link die u heeft gekregen en probeer het opnieuw.',
    linkProblemGeneric:
      'Er is een probleem met de link die u heeft gevolgd. Probeer het opnieuw.',
    contactPerson:
      'Als het probleem aanhoudt, laat dit dan weten aan de persoon van wie u de link heeft gekregen.',
    errorCode: 'Foutcode: {code}',
  },
};

export default nl;
